import { useContext } from 'react';
import JWTContext from '../contexts/JWTContext';

//-----------------------|| AUTH HOOKS ||-----------------------//

const useAuth = () => useContext(JWTContext);

export default useAuth;
